import _ from 'lodash';

/**
 * Helper function which takes the change event on an HTML form element and sets
 * the React state.
 *
 * Make sure you:
 * 1. Set the name on the form element to the same key in the state
 * 2. Bind the this context in the React component constructor
 *
 * @param {any} event		The HTML change event
 */
export function handleInputChange (event) {
	const target = event.target;
	const value = target.type === 'checkbox' ? target.checked : target.value;
	const name = target.name;

	this.setState({
		[name]: value
	});
}

/**
 * Helper function which takes the change event on an HTML form element and sets
 * the React state.
 *
 * Make sure you:
 * 1. Set the name on the form element to the same key in the state
 * 2. Bind the this context in the React component constructor
 *
 * @param {any} event				The HTML blur event
 * @param {any} validationFunc		The revalidator function to call to set the formErrors properly
 */
export function handleBlur (event, validationFunc) {
	event.persist();
	this.setState(function (previousState) {
		const blurredFields = _.chain(previousState.blurredFields || [])
			.cloneDeep()
			.concat(event.target.name)
			.uniq()
			.value();

		const formData = { ...previousState };
		return {
			blurredFields,
			formErrors: _.get(validationFunc(formData), 'errors', [])
		};
	});
}

export function submitForm (shouldSubmit = true, submitFn) {
	return function (ev) {
		ev.preventDefault();
		return shouldSubmit && submitFn();
	};
}

export function getFormError (blurredFields, formErrors, validation) {
	return function (name) {
		if (blurredFields.includes(name)) {
			let error = _.get(formErrors.find(error => error.property === name), 'message');
			return validation[error];
		}
	};
}

export function buttonify (fn) {
	return event => [' ', 'Enter'].includes(event.key) && fn(event);
}
